import { z } from 'zod';

// お気に入り登録リクエスト
export interface FavoriteVideoReq {
  video_id: string;
}

export const FavoriteVideoReqSchema = z.object({
  video_id: z.string()
});

// お気に入り登録レスポンス
export const FavoriteVideoResSchema = z.object({
  success: z.boolean(),
  message: z.string().optional()
});

export type FavoriteVideoRes = z.infer<typeof FavoriteVideoResSchema>;

// お気に入り状態確認レスポンス
export const FavoriteStatusResSchema = z.object({
  is_favorite: z.boolean()
});

export type FavoriteStatusRes = z.infer<typeof FavoriteStatusResSchema>;

// お気に入り一覧取得レスポンス
export const FavoriteListItemSchema = z.object({
  id: z.string(),
  video_id: z.string(),
  title: z.string().optional(),
  thumbnail_url: z.string().optional(),
  created_at: z.string().optional()
});

export const FavoriteListResSchema = z.array(FavoriteListItemSchema);

export type FavoriteListItem = z.infer<typeof FavoriteListItemSchema>;
export type FavoriteListRes = z.infer<typeof FavoriteListResSchema>; 